import { responseHandlerActionTypes } from './responseHandlerTypes';

const { RESPONSE } = responseHandlerActionTypes;

export const onResponse = (onResponse) => {
	return {
		type: RESPONSE,
		payload: onResponse,
	};
};
